import { useCustomTheme } from 'contexts/theme'

const AllDoneSVG = () => {
  const {
    theme: { setup },
  } = useCustomTheme()

  return (
    <>
      <svg width='480' height='391' viewBox='0 0 480 391' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_330_628)'>
          <circle cx='200.266' cy='229.972' r='86.8677' fill='url(#paint0_linear_330_628)' />
          <circle cx='125.912' cy='295.718' r='17.8782' fill='url(#paint1_linear_330_628)' />
          <circle
            cx='200.266'
            cy='229.972'
            r='101.5'
            stroke='url(#paint2_linear_330_628)'
            strokeWidth='2'
            strokeDasharray='5 5'
          />
          <path
            d='M99.0317 161.21C100.785 158.894 102.688 156.695 104.726 154.626L126.257 135.675C127.077 134.5 128.169 133.541 129.439 132.878C130.709 132.216 132.12 131.87 133.553 131.87C134.985 131.87 136.397 132.216 137.667 132.878C138.937 133.541 140.029 134.5 140.849 135.675L195.922 191.727C196.698 193.096 197.824 194.235 199.183 195.028C200.543 195.82 202.089 196.238 203.663 196.238C205.237 196.238 206.782 195.82 208.142 195.028C209.502 194.235 210.627 193.096 211.403 191.727L340.324 63.4296C341.093 62.0389 342.221 60.8798 343.59 60.0726C344.959 59.2654 346.519 58.8397 348.109 58.8397C349.698 58.8397 351.258 59.2654 352.627 60.0726C353.996 60.8798 355.124 62.0389 355.894 63.4296L378.493 86.2064C379.65 87.0289 380.593 88.1163 381.244 89.3778C381.895 90.6392 382.234 92.0381 382.234 93.4576C382.234 94.8771 381.895 96.276 381.244 97.5374C380.593 98.7989 379.65 99.8863 378.493 100.709L210.692 268.243C209.859 269.298 208.798 270.151 207.588 270.737C206.378 271.324 205.051 271.628 203.707 271.628C202.363 271.628 201.036 271.324 199.826 270.737C198.617 270.151 197.556 269.298 196.723 268.243C165.227 235.739 133.761 203.116 102.324 170.374C101.075 168.819 99.9724 167.151 99.0317 165.391V161.21Z'
            fill='url(#paint3_linear_330_628)'
          />
          <path
            d='M348.746 209.688C348.746 209.688 348.746 231.336 327.652 235.191C333.238 235.891 338.461 238.363 342.571 242.253C346.681 246.143 349.466 251.249 350.527 256.84C350.527 256.84 354.027 236.392 369.87 232.252C369.87 232.252 349.933 235.191 348.746 209.688Z'
            fill={setup.bg.main}
          />
          <path
            d='M179.151 84.8397C179.151 84.8397 179.151 92.5749 171.614 93.9525C173.61 94.2025 175.476 95.0859 176.944 96.4756C178.413 97.8654 179.408 99.6901 179.787 101.688C179.787 101.688 181.038 94.3816 186.699 92.9023C186.699 92.9023 179.575 93.9525 179.151 84.8397Z'
            fill='white'
          />
        </g>
        <defs>
          <linearGradient
            id='paint0_linear_330_628'
            x1='294.979'
            y1='343.032'
            x2='151.508'
            y2='170.417'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.main} />
            <stop offset='1' stopColor={setup.main} />
          </linearGradient>
          <linearGradient
            id='paint1_linear_330_628'
            x1='138.1'
            y1='282.198'
            x2='108.034'
            y2='323.727'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} />
            <stop offset='1' stopColor={setup.bg.dark} stopOpacity='0.59' />
          </linearGradient>
          <linearGradient
            id='paint2_linear_330_628'
            x1='252.766'
            y1='127.472'
            x2='112.766'
            y2='286.84'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.info.light} />
            <stop offset='1' stopColor={setup.bg.main} stopOpacity='0.22' />
          </linearGradient>
          <linearGradient
            id='paint3_linear_330_628'
            x1='203.766'
            y1='254.84'
            x2='537.766'
            y2='22.8397'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={setup.bg.main} />
            <stop offset='1' stopColor={setup.bg.main} stopOpacity='0' />
          </linearGradient>
          <clipPath id='clip0_330_628'>
            <rect width='480' height='389.688' fill='white' transform='translate(0 0.655884)' />
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export default AllDoneSVG
